<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="grid bg-white">
          <div id="active-employee-panel" class="grid-body">
            <div id="active-employee-details">
              <img
                :src="
                  currentEmployee.object
                    ? currentEmployee.object.picture
                    : '/assets/img/profile.png'
                "
                width="70"
                height="70"
              />
              <div id="active-employee-name">
                <h4>Currently Active Employee is</h4>
                <h3 class="semi-bold">
                  {{
                    currentEmployee.object
                      ? currentEmployee.object.employee_name
                      : "No Employee Set"
                  }}
                </h3>
              </div>
            </div>

            <div id="active-employee-station">
              <h3>
                {{
                  currentEmployee.station
                    ? currentEmployee.station.name
                    : "No Station Set"
                }}
              </h3>
            </div>

            <div id="active-employee-switch">
              <button
                @click="showChangeCurrentEmployeeModal()"
                class="btn btn-primary"
              >
                Not you? Change...
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <input
          type="text"
          @change="onBarcodeValueChanged"
          v-model="barcodeValue"
          :disabled="currentEmployee.object == null"
          placeholder="SCAN"
          class="form-control bar-code-form-control"
        />
      </div>
    </div>

    <div class="row margin-top-30">
      <div class="col-md-12">
        <div class="row">
          <div id="timer-container" class="col-md-12">
            <button
              id="timer-continue-button"
              @click="startClock()"
              :disabled="
                currentEmployee.object === null ||
                currentJob.job === null ||
                currentJob.running
              "
            >
              Continue
            </button>
            <div id="timer">{{ currentJob.time }}</div>
            <button
              id="timer-pause-button"
              @click="stopClock()"
              :disabled="
                currentEmployee.object == null ||
                currentJob.job === null ||
                !currentJob.running
              "
            >
              Pause
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center margin-top-30">
            <button
              id="timer-delete-button"
              @click="doScanReset()"
              :disabled="
                currentEmployee.object == null || currentJob.job === null
              "
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row margin-top-30">
      <div class="col-md-12">
        <div class="grid bg-white">
          <div class="grid-title">
            <h4 class="text-black text-bold">
              <label class="badge badge-info">{{ pastJobs.length }}</label>
              Previous Scans
            </h4>
          </div>
          <div class="grid-body">
            <div
              class="well well-sm previous-scan-container"
              v-for="job in pastJobs"
            >
              <h4 class="semi-bold">#{{ job.shirt_order_id }}</h4>
              <h4>{{ new Date(job.duration).toISOString().slice(14, 19) }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Change Active Employee</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <div>
                <v-select
                  :options="pageData.employees"
                  v-model="changeCurrentEmployeeModal.employee"
                  label="title"
                  placeholder="Select Employee"
                  @input="
                    (val) => {
                      var defaultStation = pageData.stations.filter(
                        (station) => station.id == val.station_id
                      );
                      if (defaultStation.length > 0) {
                        changeCurrentEmployeeModal.station = defaultStation[0];
                      }
                    }
                  "
                  :get-option-label="
                    (option) =>
                      option.employee_id + ' - ' + option.employee_name
                  "
                >
                  <template v-slot:option="option">
                    [{{ option.employee_id }}] - {{ option.employee_name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="form-group">
              <div>
                <v-select
                  :options="pageData.stations"
                  v-model="changeCurrentEmployeeModal.station"
                  label="title"
                  placeholder="Select Station"
                  :get-option-label="
                    (option) => option.department + ' - ' + option.name
                  "
                >
                  <template v-slot:option="option">
                    [{{ option.department }}] - {{ option.name }}
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="changeActiveEmployee()"
            >
              Change
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import vSelect from "vue-select";
import vueCountryRegionSelect from "vue-country-region-select";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      barcodeValue: null,
      currentJob: {
        job: null,
        time: "00:00:00",
        timeBegan: null,
        timeStopped: null,
        stoppedDuration: 0,
        intervalId: null,
        running: false,
      },
      pastJobs: [],
      currentEmployee: {
        object: null,
        station: null,
      },
      pageData: {
        employees: [],
        stations: [],
      },
      changeCurrentEmployeeModal: {
        employee: null,
        station: null,
      },
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/performance_scanning/scan",
        });
        this.pageData = results.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load page data, contact the admins");
        }
      }
    },

    showChangeCurrentEmployeeModal() {
      show_modal("#modal-box");
    },

    changeActiveEmployee() {
      this.currentEmployee.object = this.changeCurrentEmployeeModal.employee;
      this.currentEmployee.station = this.changeCurrentEmployeeModal.station;
      hide_modal("#modal-box");
    },

    onBarcodeValueChanged(event) {
      const ornr = event.target.value;
      this.barcodeValue = "";
      if (this.currentJob.job === null) {
        this.doScanFirst(ornr);
      } else {
        this.doScanEnd(ornr);
      }
    },

    async doScanFirst(ornr) {
      try {
        let results = await axios({
          method: "post",
          url: "/v2/performance_scanning/scan/start",
          data: {
            shirt_order_id: ornr,
          },
        });
        if (results.data.status) {
          this.currentJob.job = results.data.data;
          this.startClock();
        }
      } catch (error) {
        await Swal.fire({
          title: "Unable to retrieve shirt order details.",
          type: "error",
        });
      }
    },

    async doScanEnd() {
      this.stopClock();
      try {
        const elapsedTime =
          this.currentJob.timeStopped -
          this.currentJob.timeBegan -
          this.currentJob.stoppedDuration;

        let results = await axios({
          method: "post",
          url: "/v2/performance_scanning/scan/end",
          data: {
            employee_id: this.currentEmployee.object.employee_id,
            station_id: this.currentEmployee.station.id,
            scan_start_date: this.currentJob.timeBegan,
            scan_end_date: this.currentJob.timeStopped,
            task_duration: elapsedTime,
            ...this.currentJob.job,
          },
        });
        if (results.data.status) {
          this.pastJobs.push({
            shirt_order_id: this.currentJob.job.shirt_order_id,
            duration: elapsedTime,
          });
          this.currentJob.job = null;
          this.resetClock();
        }
      } catch (error) {
        await Swal.fire({
          title:
            "There was an error saving this task, contact the IT team who will be help you recover the data. Do not close the browser.",
          type: "error",
        });
      }
    },

    doScanReset() {
      this.currentJob.job = null;
      this.resetClock();
    },

    startClock() {
      if (this.currentJob.running) {
        return;
      }

      if (this.currentJob.timeBegan === null) {
        this.resetClock();
        this.currentJob.timeBegan = new Date();
      }

      if (this.currentJob.timeStopped !== null) {
        this.currentJob.stoppedDuration +=
          new Date() - this.currentJob.timeStopped;
      }

      this.currentJob.intervalId = setInterval(this.updateClock, 1);
      this.currentJob.running = true;
    },

    stopClock() {
      this.currentJob.running = false;
      this.currentJob.timeStopped = new Date();
      clearInterval(this.currentJob.intervalId);
    },

    resetClock() {
      this.currentJob.running = false;
      clearInterval(this.currentJob.intervalId);
      this.currentJob.stoppedDuration = 0;
      this.currentJob.timeBegan = null;
      this.currentJob.timeStopped = null;
      this.currentJob.time = "00:00:00";
    },

    updateClock() {
      const currentTime = new Date();
      const timeElapsed = new Date(
        currentTime -
          this.currentJob.timeBegan -
          this.currentJob.stoppedDuration
      );

      const min = timeElapsed.getUTCMinutes();
      const sec = timeElapsed.getUTCSeconds();
      const ms = timeElapsed.getUTCMilliseconds();

      this.currentJob.time =
        String(min).padStart(2, "0") +
        ":" +
        String(sec).padStart(2, "0") +
        ":" +
        String(ms).substring(0, 2).padStart(2, "0");
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.col-form-label {
  margin-top: 10px;
}

.margin-top-30 {
  margin-top: 30px;
}

#active-employee-panel {
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

#active-employee-details,
#active-employee-station,
#active-employee-switch {
  flex-basis: 33%;
}

#active-employee-details {
  flex-basis: 33%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#active-employee-details img {
  margin-right: 15px;
  border-radius: 35px;
}

#active-employee-name h3 {
  margin-top: 0px;
}

#active-employee-name h4 {
  margin-bottom: 0px;
}

#active-employee-station {
  text-align: center;
}

#active-employee-switch {
  text-align: right;
}

.bar-code-form-control {
  font-size: 90px !important;
  height: 200px;
  text-align: center;
}

#timer-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

#timer {
  background: black;
  color: white;
  padding: 25px 75px;
  margin: 0 50px;
  font-size: 120px !important;
  font-weight: bold;
}

#timer-continue-button,
#timer-pause-button {
  width: 90px;
  height: 90px;
  border: 0px;
  text-indent: -5000em;
}

#timer-continue-button {
  background: url("/assets/img/play-button.png") top left no-repeat;
  background-size: cover;
}

#timer-pause-button {
  background: url("/assets/img/pause-button.png") top left no-repeat;
  background-size: cover;
}

#timer-delete-button {
  background: url("/assets/img/trash.png") top left no-repeat;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 0px;
  text-indent: -5000em;
}

#timer-continue-button:disabled,
#timer-pause-button:disabled,
#timer-delete-button:disabled {
  opacity: 0.5;
}

.previous-scan-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 5px 15px;
}

.previous-scan-container h4.semi-bold {
  text-align: left;
}

.previous-scan-container h4 {
  flex: 1;
  text-align: right;
}
</style>
